import { render, staticRenderFns } from "./ModalNewPlan.vue?vue&type=template&id=139955ac&scoped=true"
import script from "./ModalNewPlan.vue?vue&type=script&lang=js"
export * from "./ModalNewPlan.vue?vue&type=script&lang=js"
import style0 from "./ModalNewPlan.vue?vue&type=style&index=0&id=139955ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139955ac",
  null
  
)

export default component.exports